module.exports = __webpack_public_path__ + "static/img/logo.fa92e4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1